module.exports = __webpack_public_path__ + "static/media/intro1.bc69ea4e.jpg";